import { css } from 'lit';

export const styles = css`:host{padding:.625rem .5rem;min-height:2.75rem}`;
